import { forwardRef, Module } from '@nestjs/common';
import { EmployeeDetailsService } from './employee-details.service';
import { EmployeeDetailsController } from './employee-details.controller';
import { EmployeeDetails } from './employee-details.entity';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EmployeesAdapter } from './dto/employees-adapter';
import { UserEntity } from '../user/user.entity';
import { AuthModule } from '../auth/auth.module';
import { UserModule } from '../user/user.module';
// import { Attendance } from '../attendance/attendance.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AttendanceService } from '@gtpl/shared-services/hrms';

@Module({
  imports: [
    TypeOrmModule.forFeature([EmployeeDetails, UserEntity]),
    AuthModule, UserModule,
    // forwardRef(() => ProjectMappingModule)
  ],

  providers: [EmployeeDetailsService, EmployeesAdapter, ApplicationExceptionHandler, AttendanceService],
  controllers: [EmployeeDetailsController],
  exports: [EmployeeDetailsService]
})
export class EmployeeDetailsModule { }
